import N8nButton from './Button.vue';

export default N8nButton;
